import { render } from "./SustainableMining.vue?vue&type=template&id=a1020472"
import script from "./SustainableMining.vue?vue&type=script&lang=js"
export * from "./SustainableMining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__